import { Route, Routes } from 'react-router-dom';
import { LoginPage } from '../features/auth/LoginPage';
import { RegisterPage } from '../features/auth/RegisterPage';
import { AppLayout } from './AppLayout';
import { OnboardingPage } from '../features/orgs/OnboardingPage';
import { ActivityPage } from '../features/activity/ActivityPage';
import { ConnectorsPage } from '../features/connectors/ConnectorsPage';
import { AgentsListPage } from '../features/agents/AgentsListPage';
import { NewAgentPage } from '../features/agents/NewAgentPage';
import { AgentDetailPage } from '../features/agents/AgentDetailPage';
import { RunDetailPage } from '../features/agents/RunDetailPage';
import { LLMKeysPage } from '../features/llm-keys/LLMKeysPage';
import { MCPServersPage } from '../features/mcp/MCPServersPage';
import { ReviewsPage } from '../features/reviews/ReviewsPage';
import { ReviewDetailPage } from '../features/reviews/ReviewDetailPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      <Route element={<AppLayout />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route index element={<AgentsListPage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="agents/new" element={<NewAgentPage />} />
        <Route path="agents/:agentID" element={<AgentDetailPage />} />
        <Route path="agents/:agentID/runs/:runID" element={<RunDetailPage />} />
        <Route path="connectors" element={<ConnectorsPage />} />
        <Route path="llm-keys" element={<LLMKeysPage />} />
        <Route path="mcp-servers" element={<MCPServersPage />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="reviews/:runID" element={<ReviewDetailPage />} />
      </Route>
    </Routes>
  );
}
